import { SearchInput } from '@nbirl/nbi-common-ui-libs';

import { useCurrentUser } from '../../../../../shared/context';
import { Permission } from '../../../../../shared/enum';
import { CreateFolder } from '../../../folders/components';
import { useFolderTree } from '../../../folders/context';
import { Folder } from '../../../folders/models';
import { BulkUpload } from '../../../uploads/components';

type DocumentsListFiltersProps = {
  folder: Folder;
  search: string;
  onSearchChange: (value: string) => void;
  onCreateFolderSuccess: () => void;
};

export const DocumentsListFilters: React.FC<DocumentsListFiltersProps> = ({
  folder,
  search,
  onSearchChange,
  onCreateFolderSuccess,
}) => {
  const { selectedFolderPath } = useFolderTree();
  const user = useCurrentUser();
  const path = `/${selectedFolderPath.map((f) => f.name).join('/')}${
    selectedFolderPath.length > 0 ? '/' : ''
  }${folder.name}`;

  return (
    <div className="flex items-center space-x-6 mb-5">
      <SearchInput className="w-80" value={search} onChange={onSearchChange} />

      {user.permissions.includes(Permission.ManageFolders) && (
        <CreateFolder
          onSuccess={onCreateFolderSuccess}
          parentId={folder.id}
          modalHeading="New Folder"
          text="Create folder"
        />
      )}

      {user.permissions.includes(Permission.UploadDocuments) && (
        <BulkUpload folderId={folder.id} path={path} />
      )}
    </div>
  );
};
